export enum CodemirrorCompletionType {
  ENUM = 'enum',
  VARIABLE = 'variable',
  METHOD = 'method',
}
